import styled from "styled-components";

// TODO: Delete it when https://github.com/FINVIA/mono/issues/6472 is merged
export const IconWrapper = styled.div`
  &:hover {
    cursor: pointer;
  }
`;
